export default "__VITE_PUBLIC_ASSET__172ead23__"